"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRtColumn = void 0;
var tslib_1 = require("tslib");
var Header_1 = tslib_1.__importDefault(require("./Header"));
var Cell_1 = tslib_1.__importDefault(require("./Cell"));
var options_1 = require("./filter/options");
function createRtColumn(column, index) {
    var id = column.id, _a = column.width, width = _a === void 0 ? 'auto' : _a, filter = column.filter;
    var accessor = ('accessor' in column ? column.accessor : undefined);
    // // maxWidth: 给了 width 的 column 不再 grow
    // const widthOptions = width != null ? { width, maxWidth: width } : {}
    // 计算和缓存rowSpan=0的情况
    var rowSpans = [];
    return tslib_1.__assign(tslib_1.__assign({ id: id !== null && id !== void 0 ? id : "column-index-" + index, accessor: accessor,
        // eslint-disable-next-line @typescript-eslint/naming-convention, react/display-name
        Header: Header_1.default,
        // eslint-disable-next-line @typescript-eslint/naming-convention, react/display-name
        Cell: Cell_1.default,
        width: width }, options_1.createRtFilterOptions(filter)), { meta: tslib_1.__assign(tslib_1.__assign({}, column), { rowSpans: rowSpans }) });
}
exports.createRtColumn = createRtColumn;
//# sourceMappingURL=column-options.js.map